export default class CurrentUser {
	userName!: string
	account!: string
	userId!: string
}
